import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core'

@Component({
  selector: 'card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
})
export class CardComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
